import { render } from "./MachineDetails.vue?vue&type=template&id=52a4b75b"
import script from "./MachineDetails.vue?vue&type=script&lang=js"
export * from "./MachineDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__